import GetConversationTranscriptResponseActionHandler from './message-handlers/response-action-handler';
import GetConversationTranscriptExtResponseHandler from './message-handlers/ext-response-handler';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';

export default class GetConversationTranscript {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _responseActionHandler: GetConversationTranscriptResponseActionHandler;
    _extResponseHandler: GetConversationTranscriptExtResponseHandler;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
        this._responseActionHandler = new GetConversationTranscriptResponseActionHandler(settings);
        this._extResponseHandler = new GetConversationTranscriptExtResponseHandler(settings);
    }

    getResponseActionHandler() {
        return this._responseActionHandler;
    }

    getExtResponseHandler(){
        return this._extResponseHandler;
    }
}


// WEBPACK FOOTER //
// ./modules/get-conversation-transcript/get-conversation-transcript.ts